import { render, staticRenderFns } from "./BuySellOfferView.vue?vue&type=template&id=3903bf70&scoped=true"
import script from "./BuySellOfferView.vue?vue&type=script&lang=ts"
export * from "./BuySellOfferView.vue?vue&type=script&lang=ts"
import style0 from "./BuySellOfferView.vue?vue&type=style&index=0&id=3903bf70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3903bf70",
  null
  
)

export default component.exports